import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'

import {NavbarPlugin, CollapsePlugin} from 'bootstrap-vue'

import Notifications from 'vue-notification'

import VueSlideoutPanel from 'vue2-slideout-panel'

import 'v-slim-dialog/dist/v-slim-dialog.css'
import SlimDialog from 'v-slim-dialog'

import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'

import VueClipboard from 'vue-clipboard2'
import VueScrollTo from 'vue-scrollto'

import DefaultLayout from './layouts/Default.vue'
import SingleLayout from './layouts/Single.vue'

import ProspectPanel from '@/components/panels/ProspectPanel.vue'
import EmailBuilderPanel from '@/components/panels/EmailBuilderPanel.vue'
import EmailBuilderBulkPanel from '@/components/panels/EmailBuilderBulkPanel.vue'
import SmsBuilderPanel from '@/components/panels/SmsBuilderPanel.vue'
import PreviewConfigurationTextPanel from '@/components/panels/PreviewConfigurationTextPanel.vue'

import './filters'
// Load vendor styles before the CRM theme in both development and production.
import 'tabler/dist/css/tabler.min.css'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import './sass/_main.scss'

Vue.use(NavbarPlugin)
Vue.use(CollapsePlugin)

Vue.use(Notifications)

Vue.use(VueSlideoutPanel)

Vue.use(SlimDialog)

Vue.use(VueClipboard)

Vue.use(VueScrollTo, {
  offset: (element) => {
    const header = document.querySelector('.app-header')
    const target = typeof element === 'string' ? document.querySelector(element) : element
    const sectionHeading = target?.closest('.library-card')?.querySelector('.item-list-heading')
    const headerHeight = header?.getBoundingClientRect().height || 0
    const sectionHeight = sectionHeading?.getBoundingClientRect().height || 0
    return header ? -headerHeight - sectionHeight - 24 : 0
  }
})

Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker)

Vue.component('default-layout', DefaultLayout)
Vue.component('single-layout', SingleLayout)

Vue.component('prospectPanel', ProspectPanel)
Vue.component('emailBuilderPanel', EmailBuilderPanel)
Vue.component('emailBuilderBulkPanel', EmailBuilderBulkPanel)
Vue.component('smsBuilderPanel', SmsBuilderPanel)
Vue.component('previewConfigurationTextPanel', PreviewConfigurationTextPanel)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
